import React, { useEffect, useState, useRef } from "react";
import { Button, message, Modal } from "antd";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Bill, TrashRedIcon } from "../../../Icon1";
import Card from "./itemsCard/Card";
import { BsArrowReturnRight } from "react-icons/bs";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  createTableOrder,
  getCustomerById,
  updateCustomerDetails,
  updateExcludeGST,
  resetCustomerDetails,
  updateDisplayAttachPartyDrawer,
  updateDisplayCloseOrderDrawer,
  updateDisplayTakePaymentDrawer,
  updateDisplayDiscountDrawer,
} from "../../../../reducer/posReducer/restaurant";
import {
  getAllPayments,
  updateEditPaymentDrawer,
} from "../../../../reducer/paymentReducer";
import {
  getCustomerByPhone,
  putCustomerById,
  saveCustomer,
} from "../../../../reducer/customerReducer";
import { CURRENCY_FORMAT, GET_ISO_FORMAT } from "../../../../utils/helper";
import {
  getBookingDetailsByItsIdAndRedirect,
  resetState,
  updateShowPaymentModeDropdown,
  updateOrderAndInvoice,
  updateIsCompanyInputFocused,
} from "../../../../reducer/orderReducer";
import { GoTrash } from "react-icons/go";

import {
  GET_ITEM_PRICE,
  ITEMS_TOTAL_AMOUNT,
  POS_TYPE,
} from "../../../../utils/posHelper";
import { FaChevronRight } from "react-icons/fa";

import {
  updateAllOrdersByStatus,
  updateInvoice,
  setInvoicePostData,
} from "../../../../reducer/orderReducer";

import DeleteOrderModal from "./DeleteOrderModal";
import GenerateKOT from "./GenerateKOT";
import GenerateInvoice from "./GenerateInvoice";
import useDebounce from "../../../../hooks/useDebounce";
import { CircularProgress, Tooltip } from "@mui/material";
import AttachRoomPartyDrawer from "./AttachRoomPartyDrawer";
import CloseOrderDrawer from "./CloseOrderDrawer";
import TakePaymentDrawer from "./TakePaymentDrawer";
import ApplyDiscountDrawer from "./DiscountDrawer";
import {
  updateActiveTab as updateBookingActiveTab,
  updateShowMainBookingDetailsDrawer,
} from "../../../../reducer/bookingReducer";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { ReactComponent as MobileUp } from "../../../../assets/icons/mobileUp.svg";
import { ReactComponent as LinkFile } from "../../../../assets/icons/linkFile.svg";
import { paymentModeTypes } from "../../../../utils/helper";
import {
  updateSearchText,
  resetInfiniteScrolling,
  getPartyList,
} from "../../../../reducer/partyReducer";
import { updateAddPartyDropdownVisible } from "../../../../reducer/expenseReducer";
import AddPartyDropdown from "../../../expense/dropdowns/AddPartyDropdown";
import { TranslateText } from "../../../../utils/translation";
import useAllPosFunctions from "../../../../hooks/posCustomHook/useAllPosFunctions";
import EditPaymentDrawer from "../../../common/components/UpdatePaymentDrawer/EditPaymentDrawer";
import { FaUndo } from "react-icons/fa";
import MarkNCModal from "./MarkNCModal";

function SideContainer() {
  // --- Editable price state and handlers for priceBreakup items ---
  const [editIdx, setEditIdx] = React.useState(null);
  const [editedPrice, setEditedPrice] = React.useState("");

  // --- State for total edit ---
  const [editTotalMode, setEditTotalMode] = React.useState(false);
  const [editedTotal, setEditedTotal] = React.useState("");
  const { taxResponse } = useSelector((store) => store.tax);

  // --- Handlers for total edit ---
  const handleEditTotal = () => {
    setEditedTotal(total?.toFixed(2));
    setEditTotalMode(true);
  };

  const handleCancelTotal = () => {
    setEditTotalMode(false);
    setEditedTotal("");
  };

  const updateTaxAndTotalAndSave = (updatedPriceBreakup, invoiceDataOld) => {
    const invoiceData = JSON.parse(JSON.stringify(invoiceDataOld));
    const newPriceBreakup = JSON.parse(JSON.stringify(updatedPriceBreakup));
    applyDiscountToPriceBreakup(newPriceBreakup, invoiceData);
    updateSubTotal(newPriceBreakup, invoiceData);
    updateTaxes(newPriceBreakup, invoiceData);
    updateTotal(newPriceBreakup, invoiceData);

    // Optimistic update - immediately show calculated values in UI
    const updatedInvoiceData = {
      ...invoiceData,
      priceBreakup: newPriceBreakup,
    };
    dispatch(setInvoicePostData(updatedInvoiceData));

    // Then persist to backend
    dispatch(updateInvoice({ ...updatedInvoiceData, setTotalAsPerTax: true }));
  };

  const updateTaxes = (newPriceBreakup, invoiceData) => {
    const taxes = [];
    newPriceBreakup.forEach((item) => {
      if (item?.taxIds && item?.taxIds?.length > 0) {
        item.taxIds.forEach((tax) => {
          const taxObj = taxResponse.find((t) => t.id === tax);
          if (taxObj) {
            let taxAmount =
              ((item.discountedRate || item.rate) *
                item.count *
                taxObj.taxPercentage) /
              100;

            const existingTax = taxes.find((t) => t.id === taxObj.id);
            if (existingTax) {
              existingTax.taxAmount += parseFloat(taxAmount.toFixed(2));
            } else {
              taxes.push({
                taxAmount: parseFloat(taxAmount.toFixed(2)),
                taxId: taxObj.id,
                taxName: taxObj.taxName,
                taxPercentage: taxObj.taxPercentage,
              });
            }
          }
        });
      }
      item.addOns?.forEach((addOn) => {
        if (addOn?.taxIds && addOn?.taxIds?.length > 0) {
          addOn.taxIds.forEach((tax) => {
            const taxObj = taxResponse.find((t) => t.id === tax);
            if (taxObj) {
              let taxAmount =
                (addOn.price * addOn.count * taxObj.taxPercentage) / 100;
              const existingTax = taxes.find((t) => t.id === taxObj.id);
              if (existingTax) {
                existingTax.taxAmount += parseFloat(taxAmount.toFixed(2));
              } else {
                taxes.push({
                  taxAmount: parseFloat(taxAmount.toFixed(2)),
                  taxId: taxObj.id,
                  taxName: taxObj.taxName,
                  taxPercentage: taxObj.taxPercentage,
                });
              }
            }
          });
        }
      });
    });
    invoiceData.taxObjects = taxes;
  };

  const applyDiscountToPriceBreakup = (newPriceBreakup, invoiceData) => {
    if (!invoiceData || !newPriceBreakup) return;

    // If no discount info, set discountedRate = rate for all items
    if (!invoiceData.discountInfo) {
      newPriceBreakup.forEach((item) => {
        item.discountedRate = item.rate;
      });
      return;
    }

    const { type, value } = invoiceData.discountInfo;
    if (!type || !value || value <= 0) {
      // No discount, set discountedRate = rate
      newPriceBreakup.forEach((item) => {
        item.discountedRate = item.rate;
      });
      return;
    }

    if (type === "percentage") {
      // Apply percentage discount to each item
      newPriceBreakup.forEach((item) => {
        item.discountedRate = +(item.rate * (1 - value / 100)).toFixed(2);
      });
    } else if (type === "flat") {
      // Distribute value discount proportionally
      const itemTotals = newPriceBreakup.map(
        (item) => +item.rate * +item.count,
      );
      const sumAll = itemTotals.reduce((a, b) => a + b, 0);
      if (sumAll === 0) {
        newPriceBreakup.forEach((item) => {
          item.discountedRate = item.rate;
        });
        return;
      }
      // For each item, calculate its share of the discount
      newPriceBreakup.forEach((item, idx) => {
        const proportion = itemTotals[idx] / sumAll;
        const itemDiscountTotal = value * proportion;
        // Discount per unit
        const discountPerUnit =
          item.count > 0 ? itemDiscountTotal / item.count : 0;
        item.discountedRate = +(item.rate - discountPerUnit).toFixed(2);
      });
    } else {
      // Unknown type, fallback
      newPriceBreakup.forEach((item) => {
        item.discountedRate = item.rate;
      });
    }
    const totalDiscount = newPriceBreakup.reduce((acc, item) => {
      let itemDiscount = acc + (item.rate - item.discountedRate) * item.count;
      return itemDiscount;
    }, 0);
    invoiceData.discount = totalDiscount;
  };

  const updateSubTotal = (newPriceBreakup, invoiceData) => {
    if (!invoiceData || !newPriceBreakup) return;
    const subTotal = newPriceBreakup.reduce((acc, item) => {
      let itemTotal = acc + (item.discountedRate || item.rate) * item.count;
      if (item?.addOns && item.addOns.length > 0) {
        itemTotal += item.addOns?.reduce((sum, addOn) => {
          return sum + (addOn.price || 0) * (addOn.count || 0);
        }, 0);
      }
      return itemTotal;
    }, 0);
    invoiceData.subTotal = parseFloat(subTotal.toFixed(2));
  };

  const updateTotal = (newPriceBreakup, invoiceData) => {
    const totalTax = invoiceData?.taxObjects?.reduce((acc, tax) => {
      return acc + tax.taxAmount;
    }, 0);
    const subTotal = invoiceData.subTotal || 0;
    const totalBeforeRoundOff = parseFloat(subTotal + totalTax).toFixed(2);
    if (!roundOff) {
      invoiceData.total = totalBeforeRoundOff;
    } else {
      const total = Math.round(totalBeforeRoundOff);
      const roundOff = total - totalBeforeRoundOff;
      invoiceData.roundOff = roundOff;
      invoiceData.total = total;
    }
  };

  const handleEditClick = (index, item) => {
    setEditIdx(index);
    setEditedPrice((+item.rate * +item.count).toString());
  };

  const handleCancel = () => {
    setEditIdx(null);
    setEditedPrice("");
  };

  const handleSave = (index, item) => {
    // Calculate new rate based on edited total price and count
    const newRate = +editedPrice / +item.count;
    if (!isNaN(newRate) && newRate >= 0) {
      // Create a new priceBreakup array with the updated rate for the edited item
      // Must update both rate AND discountedRate - backend uses discountedRate for tax calculation
      const updatedPriceBreakup = (invoicePostData?.priceBreakup || []).map(
        (pItem, i) => {
          if (i === index) {
            return {
              ...pItem,
              rate: newRate,
              itemRate: newRate,
              discountedRate: newRate,
            };
          }
          return pItem;
        },
      );
      // Prepare updated invoice data
      const updatedInvoice = {
        ...invoicePostData,
        priceBreakup: updatedPriceBreakup,
      };
      // Dispatch updateInvoice to persist the change
      updateTaxAndTotalAndSave(updatedPriceBreakup, invoicePostData);
      // dispatch(updateInvoice(updatedInvoice));
    }
    setEditIdx(null);
    setEditedPrice("");
  };

  const tableOrderDetails = useSelector((state) => state.pos.tableOrder);
  const [deletePopUp, setDeletePopUp] = useState(false);

  const dispatch = useDispatch();
  const [printKOT, setPrintKOT] = useState(false);
  const [printInvoice, setPrintInvoice] = useState(false);
  const [paymentModesExpanded, setPaymentModesExpanded] = useState(false);

  const { activePosType, roundOff, response } = useSelector(
    (store) => store.posSetting,
  );

  const { allPayments } = useSelector((store) => store.payments);

  const { allRooms, selectedItem, loadingCustomerApi, customerDetails } =
    useSelector((store) => store.pos);

  const { data: allItems } = useSelector((store) => store.getItems);
  const [isServiceCharge, setIsServiceCharge] = useState(false);
  const { menuDrawer } = useSelector((store) => store.app);

  const {
    data: order,
    invoicePostData,
    invoicePostLoading,
    latestOrder,
    bookingDetails,
    isCompanyInputFocused,
    loading: orderLoading,
  } = useSelector((store) => store.order);

  const { hotelDetails } = useSelector((store) => store.login);
  const [numOfPeopleEdit, setNunOfPeopleEdit] = useState(false);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const { partyResponse } = useSelector((store) => store.party);
  const [isCloseOrder, setIsCloseOrder] = useState(false);
  const [customer, setCustomer] = useState({});
  const [isAddOnVisible, setIsAddOnVisible] = useState({});

  const [deletePartyModal, setDeletePartyModal] = useState(false);
  const [showNcModal, setShowNcModal] = useState(false);

  const handleIsAddOnVisible = (id, value) =>
    setIsAddOnVisible({ ...isAddOnVisible, [id]: value });

  const handlePrint = (value) => setPrintKOT(value);

  const handleInvoicePrint = (value) => setPrintInvoice(value);
  const componentRef = useRef(null);
  const componentInvoiceRef = useRef(null);

  let customerId = "";
  order?.forEach((item) => {
    if (!customerId && Boolean(item?.customer)) customerId = item?.customer;
  });

  const { searchText } = useSelector((store) => store.party);
  const navigate = useNavigate();

  useEffect(() => {
    const payload = {
      hotelId: hotelDetails?.id,
      invoiceId: invoicePostData?.id,
      excludePaymentMethods: [""],
    };

    if (invoicePostData?.id) dispatch(getAllPayments(payload));
  }, [invoicePostData]);

  useEffect(() => {
    if (Boolean(customerId)) {
      dispatch(
        getCustomerById({
          id: customerId,
          hotelId: hotelDetails?.id,
          invoiceId: invoicePostData?.id,
        }),
      );
    }

    setIsCustomerDetailsVisible(false);
  }, [customerId, selectedItem]);

  useEffect(() => {
    const payload = {
      hotelId: hotelDetails?.id,
      pageSize: 100,
      searchText: searchText,
      infiniteScrollDisabled: true,
      partyTypes: "source,vendor",
    };
    dispatch(getPartyList(payload));
  }, [searchText]);

  useEffect(() => {
    if (!customerDetails?.id) return;

    if (invoicePostData?.customerId === customerDetails?.id) {
      return;
    }

    let orderPayload = order?.length ? { ...order[0] } : {};

    if (
      !Object.keys(orderPayload).length ||
      !(orderPayload.customer || orderPayload.customer == null) ||
      orderPayload.customer === customerDetails.id
    ) {
      return;
    }

    orderPayload = {
      ...orderPayload,
      customer: customerDetails.id,
    };

    dispatch(
      updateOrderAndInvoice({
        orderPayload,
        invoicePayload: {
          ...invoicePostData,
          customerId: customerDetails.id,
        },
        messageDisabled: true,
      }),
    );
  }, [customerDetails?.id]);

  useEffect(() => {
    if (tableOrderDetails?.reservation) getReserveCustomer();

    if (hotelDetails?.id && tableOrderDetails?.customerNumber) {
      dispatch(
        getCustomerByPhone({
          hotelId: hotelDetails?.id,
          phone: tableOrderDetails?.customerNumber,
        }),
      );
    }

    setCustomer(customerDetails);
  }, []);

  const getReserveCustomer = async () => {
    if (hotelDetails?.id && tableOrderDetails?.customerNumber) {
      let response = await dispatch(
        getCustomerByPhone({
          hotelId: hotelDetails?.id,
          phone: tableOrderDetails?.customerNumber,
        }),
      );
      if (response?.payload) setCustomer(response?.payload);
    }
  };

  useEffect(() => {
    printPDF();
  }, [latestOrder?.id]);

  useEffect(() => {
    // update order table with customer name
    if (Object?.keys(customerDetails)?.length > 0) {
      setCustomer({
        ...customer,
        ...customerDetails,
      });
    }
  }, [customerDetails]);

  const handleNumOfPersonBlue = () => {
    if (!Boolean(tableOrderDetails?.numberOfPeople)) {
      const payload = { ...tableOrderDetails, numberOfPeople: 1 };
      dispatch(createTableOrder(payload));
    }
    setNunOfPeopleEdit(false);
  };

  const handleNumOfPersonChange = (value) => {
    const payload = { ...tableOrderDetails, numberOfPeople: value };
    dispatch(createTableOrder(payload));
  };

  const handleCustomerDetails = async (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;

    setCustomer({ ...customer, [fieldName]: fieldValue });
  };

  // Debounce function for optimizing api call when onchange apply
  const handleCustomeByphoneDebounced = useDebounce(async (obj) => {
    if (obj?.phone) {
      let customerDetails = await dispatch(
        getCustomerByPhone({
          hotelId: hotelDetails?.id,
          phone: obj?.phone,
          countryCode: obj?.countryCode,
        }),
      );

      // store customer details into pos customer
      if (Boolean(customerDetails?.payload?.name)) {
        dispatch(updateCustomerDetails(customerDetails?.payload));
        setIsCustomerDetailsVisible(false);
      } else {
        dispatch(updateCustomerDetails(customerDetails?.payload));
      }
    }
  }, 500);

  const submitCustomerDetails = async (e) => {
    e.preventDefault();

    let payload = {
      ...customer,
      dob: Boolean(customer.dob) ? GET_ISO_FORMAT(customer.dob) : null,
      anniversary: Boolean(customer.anniversary)
        ? GET_ISO_FORMAT(customer.doanniversaryb)
        : null,
      hotelId: hotelDetails.id,
    };

    if (customerDetails?.name) {
      // customer exist, update customer

      let customerUpdatedDetails = await dispatch(
        putCustomerById({ ...customer, invoiceIds: invoicePostData?.id }),
      );

      if (Boolean(customerUpdatedDetails?.payload)) {
        dispatch(updateCustomerDetails(customerUpdatedDetails?.payload));
        message.success("Customer details successfully updated");
      }
    } else {
      // create customer
      let customer = await dispatch(
        saveCustomer({
          ...payload,
          phone: payload.phoneNumber,
          contactDetails: {
            countryCode: payload.countryCode,
            phoneNumber: payload.phoneNumber,
          },
        }),
      );
      if (Boolean(customer?.payload)) {
        // making API call to put the response with invoiceId as params, as per Satyam's convention

        if (invoicePostData?.id) {
          await dispatch(
            putCustomerById({
              ...customer?.payload,
              invoiceIds: invoicePostData?.id,
            }),
          );
        }

        dispatch(updateCustomerDetails(customer?.payload));
        message.success("Customer details successfully saved");
      }
    }

    setIsCustomerDetailsVisible(false);
  };

  // seleceted food item with quantity
  let selectedItemWithQuantity = [];
  let itemCountMap = {};
  let itemTotalAmount = 0;

  Object.keys(selectedItem)?.forEach((id) => {
    allItems?.forEach((item) => {
      if (item.id === id && selectedItem[id].count !== 0) {
        selectedItemWithQuantity.push({
          ...item,
          quantity: selectedItem[id].count,
        });

        itemTotalAmount +=
          GET_ITEM_PRICE(tableOrderDetails.type, activePosType, item) *
          selectedItem[id].count;

        itemCountMap[id] = {
          count: selectedItem[id].count,
          instruction: Boolean(selectedItem[id].instruction)
            ? selectedItem[id].instruction
            : null,
        };

        // calculate item addon price
        item.addOns?.forEach((addonItem) => {
          if (Boolean(selectedItem[id][addonItem.name])) {
            //  price * qty
            itemTotalAmount +=
              addonItem.price * selectedItem[id][addonItem.name];

            itemCountMap[id] = {
              ...itemCountMap[id],
              addOns: {
                ...itemCountMap?.addOns,
                [addonItem?.name]: selectedItem[id][addonItem.name],
              },
            };
          }
        });
      }
    });
  });

  const printPDF = useReactToPrint({
    onAfterPrint: () => handlePrint(false),
    content: () => componentRef.current,
    documentTitle: "Kot",
  });

  const printInvoicePDF = useReactToPrint({
    onAfterPrint: () => handleInvoicePrint(false),
    content: () => componentInvoiceRef.current,
    documentTitle: "Invoice",
  });

  const {
    createBill,
    handleKOT,
    handleServiceCharge,
    deletePartyAndRoomFromPosInvoice,
    handleUndoBilled,
  } = useAllPosFunctions();

  const { loggedInUserPermissions, editPaymentAllowed, deletePaymentAllowed } =
    useSelector((store) => store.usersRestriction);
  let isOwner = loggedInUserPermissions?.includes("OWNER") ?? false;

  const {
    status,
    cgst,
    sgst,
    discount,
    subTotal,
    total,
    paid,
    serviceCharge,
    priceBreakup,
    discountInfo,
    roundOff: roundOffValue,
  } = invoicePostData || {};

  let itemPrice = ITEMS_TOTAL_AMOUNT(priceBreakup);
  const { type, value } = discountInfo || {};

  const [serviceChargeAmount, setServiceChargeAmount] = useState(serviceCharge);

  useEffect(() => {
    setServiceChargeAmount(serviceCharge);
  }, [type, value, serviceCharge]);

  useEffect(() => {
    return () => {
      dispatch(resetCustomerDetails());
    };
  }, []);

  useEffect(() => {
    let isExcludeGst = Boolean(+cgst) && Boolean(+sgst) ? true : false;
    dispatch(updateExcludeGST(isExcludeGst));
    return () => {
      dispatch(updateExcludeGST(true));
      dispatch(updateShowPaymentModeDropdown(false));
    };
  }, [invoicePostData?.id]);

  let partyName = Array.isArray(partyResponse)
    ? partyResponse
        ?.filter((Obj) => Obj?.id === invoicePostData?.partyId)
        ?.map((Obj) => Obj?.displayName)?.[0]
    : "";

  let roomName = Array.isArray(allRooms)
    ? allRooms
        ?.filter((Obj) => Obj?.id === invoicePostData?.roomId)
        ?.map((Obj) => Obj?.roomNum)?.[0]
    : "";

  const handleAttahedCloseOrder = async () => {
    const payload = {
      ...invoicePostData,
      status: "due",
      hotelId: hotelDetails?.id,
      navigate: navigate,
      navigateTo: "dashboard/pos/table-view",
    };

    dispatch(
      updateAllOrdersByStatus({
        runningOrders: order,
        status: "completed",
      }),
    );

    const response = await dispatch(updateInvoice(payload));
    if (response?.payload?.id) {
      message.success("Order closed successfully");
    }
  };

  const handleCloseOrderDueZero = async () => {
    const payload = {
      ...invoicePostData,
      status: "paid",
      hotelId: hotelDetails?.id,
      navigate: navigate,
      navigateTo: "dashboard/pos/table-view",
    };

    dispatch(
      updateAllOrdersByStatus({
        runningOrders: order,
        status: "completed",
      }),
    );

    const response = await dispatch(updateInvoice(payload));
    if (response?.payload?.id) message.success("Order closed successfully");
  };

  const handleBookingRedirection = async (roomNumber, data, e) => {
    const payload = {
      id: data?.bookingId,
      hotelId: data?.hotelId,
    };
    await dispatch(getBookingDetailsByItsIdAndRedirect(payload));
    e.stopPropagation();
  };

  useEffect(() => {
    // This useEffect will be called after handleBookingRedirection is called successfully
    if (bookingDetails?.id) {
      const status = bookingDetails?.status;
      let statusEnum = "";
      if (status === "checkedIn") statusEnum = "ongoing";
      else statusEnum = "completed";
      dispatch(updateBookingActiveTab(statusEnum));
      navigate("/dashboard/bookings");

      dispatch(
        updateShowMainBookingDetailsDrawer({
          visible: true,
          bookingId: bookingDetails?.id,
          bookingType: statusEnum,
        }),
      );
      dispatch(resetState());
    }
  }, [bookingDetails]);

  const resetSourceNameFields = () => {
    dispatch(resetInfiniteScrolling("resetPageNumber"));
    dispatch(updateSearchText(""));
    setCustomer((prevCustomer) => ({ ...prevCustomer, company: "" }));
  };

  let currentTaxObject = invoicePostData?.taxObjects || [];

  return (
    <div className="relative h-[94vh] flex flex-col overflow-hidden min-h-0">
      <div
        className=""
        onClick={() => {
          dispatch(updateIsCompanyInputFocused(false));
          dispatch(resetInfiniteScrolling("resetPageNumber"));
          dispatch(updateSearchText(""));
        }}
      >
        <div className="flex justify-between items-center border-b px-3 pb-2 pt-8 shadow-md h-[7rem]">
          <div className="flex flex-col">
            {!(
              tableOrderDetails?.type === "delivery" ||
              tableOrderDetails?.type === "pickup" ||
              activePosType == POS_TYPE[3] ||
              activePosType == POS_TYPE[4] ||
              activePosType == POS_TYPE[5]
            ) && (
              <div>
                <div className="flex">
                  <div className="text-fg-secondary text-[20px] font-semibold">
                    {tableOrderDetails?.type === "table" ? (
                      <Button>{`Table ${tableOrderDetails?.tableNumber}`}</Button>
                    ) : tableOrderDetails?.type === "room" ? (
                      <Button>{`Room ${tableOrderDetails?.tableNumber}`}</Button>
                    ) : (
                      <Button>{tableOrderDetails?.tableNumber}</Button>
                    )}

                    {" - "}
                  </div>

                  <div className="text-fg-muted text-[20px] font-normal flex">
                    <input
                      type={numOfPeopleEdit ? "number" : "text"}
                      onFocus={() => setNunOfPeopleEdit(true)}
                      onChange={(e) => handleNumOfPersonChange(e.target.value)}
                      onBlur={handleNumOfPersonBlue}
                      value={
                        numOfPeopleEdit
                          ? tableOrderDetails.numberOfPeople
                          : tableOrderDetails.numberOfPeople + " Person"
                      }
                      className={`${
                        numOfPeopleEdit ? " w-[90px]" : " w-[100px]"
                      } px-3 py-1 ml-2 bg-surface border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none block  rounded-md sm:text-sm focus:ring-1`}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-between w-[100%]">
              <div
                onClick={() =>
                  setIsCustomerDetailsVisible(!isCustomerDetailsVisible)
                }
                className="cursor-pointer flex items-center gap-1 text[16px] font-normal mb-1 mt-2 text-fg-secondary mr-2"
              >
                <p>
                  {" "}
                  {Boolean(customer?.name) ? (
                    customer?.name
                  ) : Boolean(tableOrderDetails?.name) ? (
                    tableOrderDetails?.name
                  ) : (
                    <TranslateText
                      textKey={"enter_customer_name"}
                      namespace="pos"
                    />
                  )}
                </p>

                {/* {tableOrderDetails?.stewardname} */}
                {isCustomerDetailsVisible ? (
                  <BiSolidDownArrow
                    onClick={() =>
                      setIsCustomerDetailsVisible(!isCustomerDetailsVisible)
                    }
                    style={{ color: "rgb(var(--color-accent))" }}
                  />
                ) : (
                  <BiSolidUpArrow
                    onClick={() =>
                      setIsCustomerDetailsVisible(!isCustomerDetailsVisible)
                    }
                    style={{ color: "rgb(var(--color-accent))" }}
                  />
                )}
              </div>

              {(tableOrderDetails?.type === "delivery" ||
                tableOrderDetails?.type === "pickup") && (
                <div className="text-fg-muted text-[20px] font-normal flex">
                  <input
                    type={numOfPeopleEdit ? "number" : "text"}
                    onFocus={() => setNunOfPeopleEdit(true)}
                    onChange={(e) => handleNumOfPersonChange(e.target.value)}
                    onBlur={handleNumOfPersonBlue}
                    value={
                      numOfPeopleEdit
                        ? tableOrderDetails.numberOfPeople
                        : tableOrderDetails.numberOfPeople + " Person"
                    }
                    className={`${
                      numOfPeopleEdit ? " w-[90px]" : " w-[100px]"
                    } px-3 py-1 ml-2 bg-surface border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none block  rounded-md sm:text-sm focus:ring-1`}
                  />
                </div>
              )}
            </div>
          </div>

          {order?.length > 0 && isOwner && (
            <div
              onClick={() => setDeletePopUp(true)}
              className="flex flex-col items-center gap-1 cursor-pointer"
            >
              <span>
                <TrashRedIcon />
              </span>
              <span className="text-[10px] text-fg-muted">
                <TranslateText textKey={"delete"} namespace="pos" />
              </span>
            </div>
          )}
        </div>

        {isCustomerDetailsVisible && (
          <div className="shadow-md bg-primary-light p-5 absolute  right-0 left-0 z-10">
            <div>
              <h1 className="text-[14px] mb-2 ml-2">
                <TranslateText
                  textKey={"add_customer_details"}
                  namespace="pos"
                />
              </h1>
            </div>

            <form onSubmit={submitCustomerDetails}>
              <div className="grid grid-cols-1 pl-2 w-[100%] mb-4">
                <PhoneInput
                  defaultCountry="in"
                  value={
                    Boolean(
                      customer?.["contactDetails"]?.["countryCode"] +
                      customer?.["contactDetails"]?.["phoneNumber"],
                    )
                      ? customer?.["contactDetails"]?.["countryCode"] +
                        customer?.["contactDetails"]?.["phoneNumber"]
                      : ""
                  }
                  onChange={(value, country) => {
                    const parts = country.inputValue.split(" ");
                    let countryCode = parts?.[0];

                    const joinedString = parts
                      ?.slice(1)
                      ?.map((str) => str?.replace(/\D/g, "")) // Remove non-numeric characters
                      ?.join("");

                    setCustomer({
                      ...customer,
                      phoneNumber: joinedString,
                      countryCode: countryCode,
                      phoneValue: value,
                    });

                    handleCustomeByphoneDebounced({
                      phone: joinedString,
                      countryCode: countryCode,
                    });
                  }}
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="text-xs mb-1 ml-2">
                    <TranslateText textKey={"name"} namespace="pos" />
                  </label>
                  <input
                    name="name"
                    value={Boolean(customer["name"]) ? customer["name"] : ""}
                    required
                    type="text"
                    className={`w-full px-3 py-2 ml-2 bg-surface border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none block  rounded-md sm:text-sm focus:ring-1`}
                    placeholder="Name"
                    onChange={(e) => handleCustomerDetails(e)}
                  />
                </div>

                <div>
                  <label className="text-xs mb-1 ml-2">
                    <TranslateText textKey={"name"} namespace="pos" />
                  </label>
                  <input
                    type="date"
                    name="dob"
                    // value="2017-06-01"
                    value={moment(
                      Boolean(customer["dob"]) ? customer["dob"] : "",
                    ).format("YYYY-MM-DD")}
                    onChange={(e) => handleCustomerDetails(e)}
                    className={`w-full px-3 py-2 ml-2 bg-surface border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none block  rounded-md sm:text-sm focus:ring-1`}
                    placeholder="dd/mm/yy"
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="text-xs mb-1 ml-2">
                    <TranslateText textKey={"company_name"} namespace="pos" />
                  </label>
                  <input
                    name="company"
                    value={
                      Boolean(customer["company"])
                        ? customer["company"]
                        : searchText
                    }
                    type="text"
                    className={`w-full px-3 py-2 ml-2 bg-surface border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none block  rounded-md sm:text-sm focus:ring-1`}
                    placeholder="Company Name"
                    // onChange={(e) => handleCustomerDetails(e)}
                    onClick={(e) => {
                      dispatch(updateIsCompanyInputFocused(true));
                      dispatch(resetInfiniteScrolling("resetPageNumber"));
                      e.stopPropagation();
                    }}
                    onChange={(e) => {
                      dispatch(updateSearchText(e.target.value));
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 8 && customer["company"]) {
                        resetSourceNameFields();
                      }
                    }}
                  />
                  <div
                    className={`w-[48%] h-[200px] overflow-y-scroll bg-surface z-[99999] border-neutral-300 shadow-md absolute rounded-[10px] ${
                      !isCompanyInputFocused && "invisible"
                    }`}
                  >
                    <div
                      className="w-full h-[38px] bg-surface flex items-center justify-start pl-[10px] cursor-pointer border-b-[1px] border-b-surface-muted"
                      onClick={(e) => {
                        dispatch(updateAddPartyDropdownVisible(true));
                        dispatch(updateIsCompanyInputFocused(false));
                        resetSourceNameFields();
                        e.stopPropagation();
                      }}
                    >
                      <span className="text-[13px] leading-[18px] text-primary">
                        <TranslateText
                          textKey={"add_company"}
                          namespace="pos"
                        />
                      </span>
                    </div>
                    {partyResponse?.map((party) => {
                      const { id, displayName } = party;
                      return (
                        <div
                          key={id}
                          className="w-full h-[38px] bg-surface flex items-center justify-start pl-[10px] border-b-[1px] border-b-surface-muted cursor-pointer"
                          onClick={(e) => {
                            setCustomer({
                              ...customer,
                              company: displayName,
                            });

                            dispatch(updateSearchText(""));

                            dispatch(updateIsCompanyInputFocused(false));
                            e.stopPropagation();
                          }}
                        >
                          <span className="text-[13px] leading-[18px] text-fg-muted">
                            {displayName}
                          </span>
                        </div>
                      );
                    })}

                    <div className="w-full h-[38px] bg-surface flex items-center justify-center pl-[10px] border-b-[1px] border-b-surface-muted">
                      <span className="text-[13px] leading-[18px] text-fg-muted">
                        <TranslateText
                          textKey={"end_of_the_list"}
                          namespace="pos"
                        />
                      </span>
                    </div>
                  </div>
                </div>

                <div>
                  <label className="text-xs mb-1 ml-2">
                    <TranslateText textKey={"gstin"} namespace="pos" />
                  </label>
                  <input
                    name="gstIN"
                    value={Boolean(customer["gstIN"]) ? customer["gstIN"] : ""}
                    type="text"
                    className={`w-full px-3 py-2 ml-2 bg-surface border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none block  rounded-md sm:text-sm focus:ring-1`}
                    placeholder="GSTIN"
                    onChange={(e) => handleCustomerDetails(e)}
                  />
                </div>
                <AddPartyDropdown
                  inPos={true}
                  partyType="source"
                  setCustomer={setCustomer}
                  customer={customer}
                />
              </div>

              <div className="grid grid-cols-1  mb-4">
                <label className="text-xs mb-1 ml-2">
                  <TranslateText textKey={"address"} namespace="pos" />
                </label>
                <input
                  name="address"
                  value={
                    Boolean(customer["address"]) ? customer["address"] : ""
                  }
                  type="text"
                  className={`w-full px-3 py-2 ml-2 bg-surface border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none block  rounded-md sm:text-sm focus:ring-1`}
                  placeholder="Address"
                  onChange={(e) => handleCustomerDetails(e)}
                />
              </div>

              {loadingCustomerApi ? (
                <input
                  disabled={true}
                  type="submit"
                  value="loading..."
                  className="w-full bg-primary h-10 ml-2 rounded-md text-fg-inverse cursor-pointer hover:bg-primary"
                />
              ) : (
                <input
                  type="submit"
                  value="Save Details"
                  className="w-full bg-primary h-10 ml-2 rounded-md text-fg-inverse cursor-pointer hover:bg-primary"
                />
              )}
            </form>
          </div>
        )}

        {/*  */}
        <div className="flex flex-col pt-4">
          <div className="flex-1 px-2">
            {status === "billed" || status === "paid" ? (
              <>
                <div className="flex justify-between items-center mb-4 px-2">
                  <p className="font-bold text-lg text-fg-secondary">Total</p>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-lg text-fg-secondary">
                      {CURRENCY_FORMAT(total)}
                    </span>
                    {/* <button className="text-primary text-xs underline ml-2" onClick={handleEditTotal}>Edit</button> */}
                  </div>
                </div>

                <div className="h-48 flex-1 overflow-y-auto">
                  {priceBreakup?.map((item, idx) => (
                    <div
                      className="bg-surface rounded p-3 mb-2 "
                      key={item.id || idx}
                    >
                      <div className="flex justify-between px-2 items-center">
                        <p className="text-sm text-fg-secondary">
                          {item.type}{" "}
                          <span className="text-xs">
                            {" "}
                            ({item.rate.toFixed(2)}X{item.count})
                          </span>{" "}
                        </p>
                        {editIdx === idx ? (
                          <div className="flex items-center gap-2">
                            <input
                              type="number"
                              className="border rounded px-2 py-1 w-20 text-right"
                              value={editedPrice}
                              onChange={(e) => setEditedPrice(e.target.value)}
                              min={0}
                              step="0.01"
                            />
                            <button
                              className="text-success text-xs ml-1"
                              onClick={() => handleSave(idx, item)}
                            >
                              Save
                            </button>
                            <button
                              className="text-gray-400 text-xs ml-1"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2">
                            <p className="font-semibold text-sm text-fg-muted">
                              {CURRENCY_FORMAT(
                                (+item.rate * +item.count).toFixed(2),
                              )}
                            </p>
                            <button
                              className="text-primary text-xs underline ml-2"
                              onClick={() => handleEditClick(idx, item)}
                            >
                              Edit
                            </button>
                          </div>
                        )}
                      </div>
                      {item.addOns?.map((addOn, addOnIdx) => (
                        <div
                          className="flex justify-between px-2 mt-0"
                          key={addOn.id || addOnIdx}
                        >
                          <div className="flex">
                            <span className="mt-1">
                              <BsArrowReturnRight />
                            </span>
                            <span className="text-[14px] text-fg-secondary ml-2 mr-2 ">
                              {addOn.name}

                              <span className="text-xs">
                                {" "}
                                ({addOn.price}X{addOn.count})
                              </span>
                            </span>
                          </div>

                          <div>
                            <div className="flex flex-col gap-1">
                              <span className="text-[14px] font-medium text-fg-secondary">
                                {CURRENCY_FORMAT(
                                  (+addOn.price * +addOn.count).toFixed(2),
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="mt-5 overflow-y-auto max-h-[calc(94vh-20rem)] pb-24">
                {selectedItemWithQuantity?.map((item) => (
                  <Card
                    key={item.id}
                    item={item}
                    handleIsAddOnVisible={(id, value) =>
                      handleIsAddOnVisible(id, value)
                    }
                    isAddOnVisible={isAddOnVisible}
                  />
                ))}
              </div>
            )}
          </div>

          <div className="absolute w-full bottom-[-9px]">
            {status === "paid" ? (
              <div className="w-full rounded-t-[24px] bg-surface ">
                <>
                  <div className="p-5">
                    <div className="flex justify-between text-sm text-slate-400 mt-1 my-1 px-1">
                      <p>
                        <TranslateText textKey={"amount"} namespace="pos" />
                      </p>
                      <p>{CURRENCY_FORMAT(itemPrice)}</p>
                    </div>
                    <hr />

                    {Boolean(discount) && (
                      <>
                        <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                          <p>
                            <TranslateText
                              textKey={"discount"}
                              namespace="pos"
                            />
                            {invoicePostData?.discountInfo?.comment && (
                              <span className="ml-[0.25rem] text-xs text-fg-muted">
                                ({invoicePostData.discountInfo.comment})
                              </span>
                            )}
                          </p>
                          <p>{CURRENCY_FORMAT(discount)}</p>
                        </div>
                        <hr />
                      </>
                    )}

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <p>
                        <TranslateText textKey={"sub_total"} namespace="pos" />
                      </p>
                      <p>{CURRENCY_FORMAT(subTotal)}</p>
                    </div>

                    <hr />

                    {currentTaxObject?.map((Obj) => {
                      if (Obj?.taxAmount) {
                        return (
                          <div
                            className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1"
                            key={Obj?.id}
                          >
                            <div className="flex gap-2">
                              <p className="font-body text-[14px]">
                                {Obj?.taxName || "Tax"} ({Obj?.taxPercentage}%)
                              </p>
                            </div>
                            <p className="font-body text-[14px]">
                              {CURRENCY_FORMAT(Obj?.taxAmount)}
                            </p>
                          </div>
                        );
                      }
                      return <></>; // To avoid undefined return
                    })}

                    <hr />

                    {Boolean(+serviceCharge) && (
                      <>
                        <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                          <p>
                            <TranslateText
                              textKey={"extra_charge"}
                              namespace="pos"
                            />
                          </p>
                          <p>{CURRENCY_FORMAT(+serviceCharge)}</p>
                        </div>
                        <hr />
                      </>
                    )}

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <p className="font-semibold">
                        <TranslateText textKey={"total"} namespace="pos" />{" "}
                        <span className="bg-success text-fg-inverse px-2 rounded">
                          <TranslateText textKey={"paid"} namespace="pos" />
                        </span>{" "}
                      </p>
                      <p className="font-semibold">{CURRENCY_FORMAT(paid)}</p>
                    </div>

                    <div className="mt-[18px] cursor-pointer">
                      {allPayments?.filter(
                        (payment) => payment.method !== "btc",
                      )?.length ? (
                        <div
                          className="w-full flex justify-between items-center"
                          onClick={() =>
                            setPaymentModesExpanded(!paymentModesExpanded)
                          }
                        >
                          <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                            All Payments
                          </span>
                          {paymentModesExpanded ? (
                            <MobileUp />
                          ) : (
                            <FaChevronRight />
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      {paymentModesExpanded ? (
                        <div className="mt-[12px] flex flex-col gap-[8px]">
                          {allPayments
                            ?.filter((payment) => payment.method !== "btc")
                            ?.map((payment) => {
                              const { id, amount, method, transactionNo } =
                                payment;
                              return (
                                <div
                                  key={id}
                                  className="flex w-full justify-between items-center px-[12px] h-[40px] rounded-[8px]
                                 bg-surface-muted border-[1px] border-brand-border-muted"
                                >
                                  <div className="flex items-center gap-[6px] w-full">
                                    <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                                      {paymentModeTypes?.[method]}
                                    </span>
                                    {Boolean(transactionNo) ? (
                                      <Tooltip
                                        title={
                                          transactionNo?.length > 15
                                            ? transactionNo
                                            : ""
                                        }
                                        className="font-body font-[500] text-[10px] text-fg"
                                      >
                                        ({transactionNo?.slice(-15)})
                                      </Tooltip>
                                    ) : (
                                      <></>
                                    )}

                                    {editPaymentAllowed ? (
                                      <span
                                        onClick={(e) => {
                                          dispatch(
                                            updateEditPaymentDrawer({
                                              display: true,
                                              paymentObj: payment,
                                            }),
                                          );
                                          e.stopPropagation();
                                        }}
                                        className="font-body font-[500] text-[12px] leading-[24px] text-primary cursor-pointer"
                                      >
                                        {" "}
                                        (Edit)
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                                    {CURRENCY_FORMAT(amount)}
                                  </span>
                                </div>
                              );
                            })}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col justify-center items-center mb-2  w-[100%] ">
                    {Boolean(invoicePostData?.roomId) && (
                      <div className="w-full px-5">
                        <div className="w-full h-[40px] bg-success-light rounded-[10px] px-[10px] flex items-center justify-between mb-[14px]">
                          <div
                            className="flex items-center gap-[6px] cursor-pointer"
                            onClick={(e) =>
                              handleBookingRedirection(
                                roomName,
                                invoicePostData,
                                e,
                              )
                            }
                          >
                            <LinkFile />
                            <span className="font-body font-[500] text-[16px] text-success leading-[20.16px]">
                              <TranslateText
                                textKey={"bill_attached_to_room"}
                                namespace="pos"
                              />

                              {roomName}
                            </span>
                          </div>

                          {!(paid >= 0 && invoicePostData?.roomId) && (
                            <span
                              className="font-body font-[500] text-[12px] leading-[24px] text-primary cursor-pointer"
                              onClick={() =>
                                dispatch(updateDisplayAttachPartyDrawer(true))
                              }
                            >
                              <TranslateText textKey={"edit"} namespace="pos" />
                            </span>
                          )}

                          {deletePaymentAllowed && (
                            <GoTrash
                              className="cursor-pointer text-danger h-[18px] w-[18px]"
                              onClick={() => setDeletePartyModal(true)}
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {Boolean(invoicePostData?.partyId) && (
                      <div className="w-full px-5">
                        <div className="w-full h-[40px] bg-success-light rounded-[10px] px-[10px] flex items-center justify-between mb-[14px]">
                          <div
                            className="flex items-center gap-[6px] cursor-pointer"
                            onClick={(e) =>
                              handleBookingRedirection(
                                roomName,
                                invoicePostData,
                                e,
                              )
                            }
                          >
                            <LinkFile />
                            <span className="font-body font-[500] text-[16px] text-success leading-[20.16px]">
                              {`Bill attached to ${
                                Boolean(partyName) ? partyName : ""
                              } (Party)`}
                            </span>
                          </div>

                          <span className="flex items-center gap-1">
                            <span
                              className="font-body font-[500] text-[12px] leading-[24px] text-primary cursor-pointer"
                              onClick={() =>
                                dispatch(updateDisplayAttachPartyDrawer(true))
                              }
                            >
                              EDIT
                            </span>

                            {deletePaymentAllowed && (
                              <GoTrash
                                className="cursor-pointer text-danger h-[18px] w-[18px]"
                                onClick={() => setDeletePartyModal(true)}
                              />
                            )}
                          </span>
                        </div>
                      </div>
                    )}

                    <div className=" w-[100%] flex flex-col gap-2 justify-center items-center ">
                      <div className="flex gap-2 items-center">
                        {" "}
                        <button
                          className="font-body  font-[500] text-[14px] leading-[18px] rounded-[8px] p-2 '
                     bg-primary-light text-primary text-center "
                          onClick={printInvoicePDF}
                          onMouseEnter={() => setPrintInvoice(true)}
                          onMouseLeave={() => setPrintInvoice(false)}
                        >
                          <TranslateText textKey={"print"} namespace="pos" />
                        </button>
                      </div>

                      <button
                        className="font-body font-[600] text-[18px] leading-[18px] w-[100%] 
                      bg-primary py-3 text-fg-inverse "
                        onClick={() =>
                          dispatch(updateDisplayTakePaymentDrawer(true))
                        }
                      >
                        TAKE PAYMENT
                      </button>
                    </div>
                  </div>
                </>
              </div>
            ) : status === "billed" ? (
              <div className=" rounded-t-[24px] bg-surface ">
                <>
                  <div className="p-5">
                    {itemPrice ? (
                      <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                        <p>
                          <TranslateText textKey={"amount"} namespace="pos" />
                        </p>
                        <p>{CURRENCY_FORMAT(itemPrice)}</p>
                      </div>
                    ) : (
                      <></>
                    )}

                    <hr />

                    {discount ? (
                      <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                        <p>
                          <TranslateText textKey={"discount"} namespace="pos" />
                          {invoicePostData?.discountInfo?.comment && (
                            <span className="ml-[0.25rem] text-xs text-fg-muted">
                              ({invoicePostData.discountInfo.comment})
                            </span>
                          )}
                        </p>
                        <p>{CURRENCY_FORMAT(discount)}</p>
                      </div>
                    ) : (
                      <></>
                    )}

                    <hr />

                    {discount ? (
                      <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                        <p className="font-semibold">
                          <TranslateText
                            textKey={"sub_total"}
                            namespace="pos"
                          />
                        </p>
                        <p className="font-semibold">
                          {CURRENCY_FORMAT(subTotal)}
                        </p>
                      </div>
                    ) : (
                      <></>
                    )}

                    <hr />

                    {currentTaxObject?.map((Obj) => {
                      if (Obj?.taxAmount) {
                        return (
                          <div
                            className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1"
                            key={Obj?.id}
                          >
                            <div className="flex gap-2">
                              <p className="font-body text-[14px]">
                                {Obj?.taxName || "Tax"} ({Obj?.taxPercentage}%)
                              </p>
                            </div>
                            <p className="font-body text-[14px]">
                              {CURRENCY_FORMAT(Obj?.taxAmount)}
                            </p>
                          </div>
                        );
                      }
                    })}

                    <hr />

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <p>
                        <TranslateText
                          textKey={"extra_charge"}
                          namespace="pos"
                        />

                        <span
                          onClick={() => setIsServiceCharge(!isServiceCharge)}
                          className="text-primary text-xs cursor-pointer"
                        >
                          {isServiceCharge ? (
                            <span>
                              (
                              <TranslateText textKey={"hide"} namespace="pos" />
                              )
                            </span>
                          ) : (
                            <span className="ml-[2px]">
                              {Boolean(serviceCharge) ? (
                                <>
                                  (
                                  <TranslateText
                                    textKey={"edit"}
                                    namespace="pos"
                                  />
                                  )
                                </>
                              ) : (
                                <>
                                  (
                                  <TranslateText
                                    textKey={"add"}
                                    namespace="pos"
                                  />
                                  )
                                </>
                              )}
                            </span>
                          )}
                        </span>
                      </p>
                      <p>{CURRENCY_FORMAT(serviceCharge)}</p>
                    </div>

                    <hr />

                    {isServiceCharge && (
                      <div className="shadow p-3 mt-2">
                        <div>
                          <div class="mb-4">
                            <h1 className="block text-gray-700 text-sm font-bold mb-2">
                              {Boolean(serviceCharge) ? "Edit" : "Add"}
                              <TranslateText
                                textKey={"service_charge"}
                                namespace="pos"
                              />
                            </h1>

                            <input
                              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="username"
                              value={serviceChargeAmount}
                              type="number"
                              placeholder="Enter here"
                              onChange={(e) =>
                                setServiceChargeAmount(e.target.value)
                              }
                            />
                            <div className="mt-3 flex justify-between">
                              <div />

                              {Boolean(serviceChargeAmount) ? (
                                <Button
                                  onClick={() =>
                                    handleServiceCharge(
                                      serviceChargeAmount,
                                      setIsServiceCharge,
                                    )
                                  }
                                >
                                  <TranslateText
                                    textKey={"apply"}
                                    namespace="pos"
                                  />
                                </Button>
                              ) : (
                                <Button disabled={true}>
                                  <TranslateText
                                    textKey={"apply"}
                                    namespace="pos"
                                  />
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {roundOffValue && (
                      <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                        <div className="flex gap-2">
                          <p className=" text-1xl">Round Off</p>
                        </div>
                        <p className="text-1xl">
                          {CURRENCY_FORMAT(roundOffValue)}
                        </p>
                      </div>
                    )}
                    <hr />
                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <div className="flex gap-2">
                        <p className="font-bold text-1xl">
                          <TranslateText textKey={"total"} namespace="pos" />
                        </p>
                      </div>
                      <p className="font-bold text-1xl">
                        {CURRENCY_FORMAT(total)}
                      </p>
                    </div>

                    <hr />

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <div className="flex gap-2">
                        <p className="text-sm text-slate-400 ">
                          <TranslateText textKey={"paid"} namespace="pos" />
                        </p>
                      </div>
                      <p className="text-sm text-slate-400">
                        {Boolean(paid) ? CURRENCY_FORMAT(paid) : 0}
                      </p>
                    </div>

                    <hr />

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <div className="flex gap-1">
                        <p className="text-sm font-400 text-danger">
                          <TranslateText textKey={"due"} namespace="pos" />
                        </p>
                      </div>
                      <p className="text-sm font-400 text-danger">
                        {Boolean(paid)
                          ? CURRENCY_FORMAT(total - paid)
                          : CURRENCY_FORMAT(total)}
                      </p>
                    </div>
                  </div>

                  <div className="mt-[0] px-3 cursor-pointer">
                    {allPayments?.filter((payment) => payment.method !== "btc")
                      ?.length ? (
                      <div
                        className="w-full flex justify-between items-center"
                        onClick={() =>
                          setPaymentModesExpanded(!paymentModesExpanded)
                        }
                      >
                        <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                          All Payments
                        </span>
                        {paymentModesExpanded ? (
                          <MobileUp />
                        ) : (
                          <FaChevronRight />
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                    {paymentModesExpanded ? (
                      <div className="mt-[12px] mb-[6px] flex flex-col gap-[8px]">
                        {allPayments
                          ?.filter((payment) => payment.method !== "btc")
                          ?.map((payment) => {
                            const { id, amount, method, transactionNo } =
                              payment;
                            return (
                              <div
                                key={id}
                                className="flex w-full justify-between items-center px-[12px] h-[40px] rounded-[8px]
                                 bg-surface-muted border-[1px] border-brand-border-muted"
                              >
                                <div className="flex items-center gap-[6px] w-full">
                                  <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                                    {paymentModeTypes?.[method]}
                                  </span>
                                  {Boolean(transactionNo) ? (
                                    <Tooltip
                                      title={
                                        transactionNo?.length > 15
                                          ? transactionNo
                                          : ""
                                      }
                                      className="font-body font-[500] text-[10px] text-fg"
                                    >
                                      ({transactionNo?.slice(-15)})
                                    </Tooltip>
                                  ) : (
                                    <></>
                                  )}

                                  {editPaymentAllowed ? (
                                    <span
                                      onClick={(e) => {
                                        dispatch(
                                          updateEditPaymentDrawer({
                                            display: true,
                                            paymentObj: payment,
                                          }),
                                        );
                                        e.stopPropagation();
                                      }}
                                      className="font-body font-[500] text-[12px] leading-[24px] text-primary cursor-pointer"
                                    >
                                      {" "}
                                      (Edit)
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                                  {CURRENCY_FORMAT(amount)}
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div
                    className="flex  flex-col items-center gap-2 pt-2 w-full bg-surface mb-2 border-[0.5px] 
                  border-t-overlay-hover rounded-t-[10px] "
                  >
                    <div className="flex gap-2 w-full justify-center">
                      <div
                        className="text-[12px] flex items-center gap-2 text-fg-muted font-[400] font-body
                   bg-primary-light px-3 py-2 rounded-md cursor-pointer leading-[20px]"
                        onClick={handleUndoBilled}
                      >
                        <FaUndo
                          color="rgb(var(--color-text-muted))"
                          className="font-[300] text-[11px]"
                        />
                        <p> Undo</p>
                      </div>

                      <Button
                        className="text-[0.875rem] border-0  text-primary font-[500] font-body bg-primary-light px-3 py-2 rounded-md cursor-pointer"
                        onClick={printInvoicePDF}
                        onMouseEnter={() => setPrintInvoice(true)}
                        onMouseLeave={() => setPrintInvoice(false)}
                      >
                        <TranslateText textKey={"print"} namespace="pos" />
                      </Button>
                    </div>

                    {tableOrderDetails?.bookingId ? (
                      <></>
                    ) : (
                      <div className="flex gap-2 items-center">
                        <Button
                          className="text-[0.875rem] border-0  text-primary font-[500] font-body bg-primary-light px-3 py-2 rounded-md cursor-pointer"
                          onClick={() =>
                            dispatch(updateDisplayAttachPartyDrawer(true))
                          }
                        >
                          <TranslateText
                            textKey={"attach_to_room_party"}
                            namespace="pos"
                          />
                        </Button>

                        <Button
                          className="text-[0.875rem] border-0  text-primary font-[500] font-body bg-primary-light px-3 py-2 rounded-md cursor-pointer"
                          onClick={() =>
                            dispatch(updateDisplayDiscountDrawer(true))
                          }
                        >
                          <TranslateText
                            textKey={
                              discount ? "edit_discount" : "apply_discount"
                            }
                            namespace="pos"
                          />
                        </Button>

                        <Button
                          className="text-[0.875rem] border-0  text-primary font-[500] font-body bg-primary-light px-3 py-2 rounded-md cursor-pointer"
                          onClick={() => setShowNcModal(!showNcModal)}
                        >
                          <TranslateText textKey={"Mark NC"} namespace="pos" />
                        </Button>
                      </div>
                    )}

                    <div className=" w-[100%] ">
                      <button
                        className="font-body font-[600] text-[18px] leading-[18px] w-[50%] bg-primary-light py-3 text-primary "
                        onClick={() =>
                          dispatch(updateDisplayTakePaymentDrawer(true))
                        }
                      >
                        <TranslateText
                          textKey={"take_payment"}
                          namespace="pos"
                        />
                      </button>

                      {total <= 0 || total - paid < 0.1 ? (
                        <button
                          className="font-body font-[600] text-[18px] leading-[18px] w-[50%] text-fg-inverse py-3  bg-primary "
                          onClick={() => handleCloseOrderDueZero()}
                        >
                          <TranslateText
                            textKey={"close_order"}
                            namespace="pos"
                          />
                        </button>
                      ) : Boolean(
                          invoicePostData?.roomId || invoicePostData?.partyId,
                        ) ? (
                        <button
                          className="font-body font-[600] text-[18px] leading-[18px] w-[50%] text-fg-inverse py-3  bg-primary "
                          onClick={() => handleAttahedCloseOrder()}
                        >
                          <TranslateText
                            textKey={"close_order"}
                            namespace="pos"
                          />
                        </button>
                      ) : (
                        <button
                          className="font-body font-[600] text-[18px] leading-[18px] w-[50%] text-fg-inverse py-3  bg-primary "
                          onClick={() =>
                            dispatch(updateDisplayCloseOrderDrawer(true))
                          }
                        >
                          <TranslateText
                            textKey={"close_order"}
                            namespace="pos"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </>
              </div>
            ) : status === "due" ? (
              <div className=" rounded-t-[24px] bg-surface ">
                <>
                  <div className="p-5">
                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <p>
                        <TranslateText textKey={"amount"} namespace="pos" />
                      </p>
                      <p>{CURRENCY_FORMAT(itemPrice)}</p>
                    </div>
                    <hr />

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <p>
                        <TranslateText textKey={"discount"} namespace="pos" />
                        {invoicePostData?.discountInfo?.comment && (
                          <span className="ml-[0.25rem] text-xs text-fg-muted">
                            ({invoicePostData.discountInfo.comment})
                          </span>
                        )}
                      </p>
                      <p>{CURRENCY_FORMAT(discount)}</p>
                    </div>
                    <hr />

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <p className="font-semibold">
                        <TranslateText textKey={"sub_total"} namespace="pos" />
                      </p>
                      <p className="font-semibold">
                        {CURRENCY_FORMAT(subTotal)}
                      </p>
                    </div>

                    <hr />

                    {currentTaxObject?.map((Obj) => {
                      if (Obj?.taxAmount) {
                        return (
                          <div
                            className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1"
                            key={Obj?.id}
                          >
                            <div className="flex gap-2">
                              <p className="font-body text-[14px]">
                                {Obj?.taxName || "Tax"} ({Obj?.taxPercentage}%)
                              </p>
                            </div>
                            <p className="font-body text-[14px]">
                              {CURRENCY_FORMAT(Obj?.taxAmount)}
                            </p>
                          </div>
                        );
                      }
                      return <></>; // To avoid undefined return
                    })}

                    <hr />

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <p>
                        <TranslateText
                          textKey={"extra_charge"}
                          namespace="pos"
                        />

                        <span
                          onClick={() => setIsServiceCharge(!isServiceCharge)}
                          className="text-primary text-xs cursor-pointer"
                        >
                          {isServiceCharge ? (
                            <span>
                              (
                              <TranslateText textKey={"hide"} namespace="pos" />
                              )
                            </span>
                          ) : (
                            <span className="ml-[2px]">
                              {Boolean(serviceCharge) ? (
                                <>
                                  (
                                  <TranslateText
                                    textKey={"edit"}
                                    namespace="pos"
                                  />
                                  )
                                </>
                              ) : (
                                <>
                                  (
                                  <TranslateText
                                    textKey={"add"}
                                    namespace="pos"
                                  />
                                  )
                                </>
                              )}
                            </span>
                          )}
                        </span>
                      </p>
                      <p>{CURRENCY_FORMAT(serviceCharge)}</p>
                    </div>
                    <hr />

                    {isServiceCharge && (
                      <div className="shadow p-3 mt-2">
                        <div>
                          <div class="mb-4">
                            <h1 className="block text-gray-700 text-sm font-bold mb-2">
                              {Boolean(serviceCharge) ? "Edit" : "Add"}
                              <TranslateText
                                textKey={"service_charge"}
                                namespace="pos"
                              />
                            </h1>

                            <input
                              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="username"
                              value={serviceChargeAmount}
                              type="number"
                              placeholder="Enter here"
                              onChange={(e) =>
                                setServiceChargeAmount(e.target.value)
                              }
                            />
                            <div className="mt-3 flex justify-between">
                              <div />

                              {Boolean(serviceChargeAmount) ? (
                                <Button onClick={handleServiceCharge}>
                                  <TranslateText
                                    textKey={"apply"}
                                    namespace="common"
                                  />
                                </Button>
                              ) : (
                                <Button disabled={true}>
                                  <TranslateText
                                    textKey={"apply"}
                                    namespace="common"
                                  />
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="flex justify-between text-sm text-slate-400 mt-2 my-1 px-1">
                      <div className="flex gap-2">
                        <p className="font-bold text-1xl">
                          <TranslateText textKey={"total"} namespace="pos" />
                        </p>
                        {status === "due" && (
                          <span className="bg-danger text-fg-inverse px-2 rounded">
                            <TranslateText textKey={"due"} namespace="home" />
                          </span>
                        )}
                      </div>
                      <p className="font-bold text-1xl">
                        {status === "due"
                          ? Boolean(paid)
                            ? CURRENCY_FORMAT(total - paid)
                            : CURRENCY_FORMAT(total)
                          : CURRENCY_FORMAT(total)}
                      </p>
                    </div>
                  </div>

                  <div className="mt-[10px] cursor-pointer px-4">
                    {allPayments?.filter((payment) => payment.method !== "btc")
                      ?.length ? (
                      <div
                        className="w-full flex justify-between items-center"
                        onClick={() =>
                          setPaymentModesExpanded(!paymentModesExpanded)
                        }
                      >
                        <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                          All Payments
                        </span>
                        {paymentModesExpanded ? (
                          <MobileUp />
                        ) : (
                          <FaChevronRight />
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                    {paymentModesExpanded ? (
                      <div className="mt-[12px] flex flex-col gap-[8px]">
                        {allPayments
                          ?.filter((payment) => payment.method !== "btc")
                          ?.map((payment) => {
                            const { id, amount, method, transactionNo } =
                              payment;
                            return (
                              <div
                                key={id}
                                className="flex w-full justify-between items-center px-[12px] h-[40px] rounded-[8px]
                                 bg-surface-muted border-[1px] border-brand-border-muted"
                              >
                                <div className="flex items-center gap-[6px] w-full">
                                  <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                                    {paymentModeTypes?.[method]}
                                  </span>
                                  {Boolean(transactionNo) ? (
                                    <Tooltip
                                      title={
                                        transactionNo?.length > 15
                                          ? transactionNo
                                          : ""
                                      }
                                      className="font-body font-[500] text-[10px] text-fg"
                                    >
                                      ({transactionNo?.slice(-15)})
                                    </Tooltip>
                                  ) : (
                                    <></>
                                  )}

                                  {editPaymentAllowed ? (
                                    <span
                                      onClick={(e) => {
                                        dispatch(
                                          updateEditPaymentDrawer({
                                            display: true,
                                            paymentObj: payment,
                                          }),
                                        );
                                        e.stopPropagation();
                                      }}
                                      className="font-body font-[500] text-[12px] leading-[24px] text-primary cursor-pointer"
                                    >
                                      {" "}
                                      (Edit)
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <span className="font-body font-[500] text-[14px] leading-[24px] text-fg">
                                  {CURRENCY_FORMAT(amount)}
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div
                    className="flex  flex-col items-center gap-2 pt-2 w-full bg-surface mb-2 
                  "
                  >
                    {Boolean(invoicePostData?.roomId) && (
                      <div className="w-full px-5">
                        <div className="w-full h-[40px] bg-success-light rounded-[10px] px-[10px] flex items-center justify-between mb-[14px]">
                          <div
                            className="flex items-center gap-[6px] cursor-pointer"
                            onClick={(e) =>
                              handleBookingRedirection(
                                roomName,
                                invoicePostData,
                                e,
                              )
                            }
                          >
                            <LinkFile />
                            <span className="font-body font-[500] text-[16px] text-success leading-[20.16px]">
                              <TranslateText
                                textKey={"bill_attached_to_room"}
                                namespace="pos"
                              />{" "}
                              {roomName}
                            </span>
                          </div>

                          {paid > 0 ? (
                            <></>
                          ) : (
                            <span className="flex items-center gap-1">
                              <span
                                className="font-body font-[500] text-[12px] leading-[24px] text-primary cursor-pointer"
                                onClick={() =>
                                  dispatch(updateDisplayAttachPartyDrawer(true))
                                }
                              >
                                <TranslateText
                                  textKey={"edit"}
                                  namespace="common"
                                />
                              </span>

                              {deletePaymentAllowed && (
                                <GoTrash
                                  className="cursor-pointer text-danger h-[18px] w-[18px]"
                                  onClick={() => setDeletePartyModal(true)}
                                />
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {Boolean(invoicePostData?.partyId) && (
                      <div className="w-full px-5">
                        <div className="w-full h-[40px] bg-success-light rounded-[10px] px-[10px] flex items-center justify-between mb-[14px]">
                          <div
                            className="flex items-center gap-[6px] cursor-pointer"
                            onClick={(e) =>
                              handleBookingRedirection(
                                roomName,
                                invoicePostData,
                                e,
                              )
                            }
                          >
                            <LinkFile />
                            <span className="font-body font-[500] text-[16px] text-success leading-[20.16px]">
                              {`Bill attached to ${
                                Boolean(partyName) ? partyName : ""
                              } (Party)`}
                            </span>
                          </div>
                          <span
                            className="font-body font-[500] text-[12px] leading-[24px] text-primary cursor-pointer"
                            onClick={() =>
                              dispatch(updateDisplayAttachPartyDrawer(true))
                            }
                          >
                            <TranslateText
                              textKey={"edit"}
                              namespace="common"
                            />
                          </span>
                        </div>
                      </div>
                    )}

                    {invoicePostData?.roomId || invoicePostData?.partyId ? (
                      <div className=" w-[100%] flex flex-col gap-2 justify-center items-center ">
                        <button
                          className="font-body w-[100%]  font-[600] text-[14px] leading-[18px]  p-2 '
                     bg-primary-light text-primary text-center "
                          onClick={printInvoicePDF}
                          onMouseEnter={() => setPrintInvoice(true)}
                          onMouseLeave={() => setPrintInvoice(false)}
                        >
                          <TranslateText textKey={"print"} namespace="pos" />
                        </button>
                      </div>
                    ) : (
                      <div className=" w-[100%] flex flex-col gap-2 justify-center items-center ">
                        <button
                          className="font-body  font-[500] text-[14px] leading-[18px] rounded-[8px] p-2 '
                     bg-primary-light text-primary text-center "
                          onClick={printInvoicePDF}
                          onMouseEnter={() => setPrintInvoice(true)}
                          onMouseLeave={() => setPrintInvoice(false)}
                        >
                          <TranslateText textKey={"print"} namespace="pos" />
                        </button>

                        <button
                          className="font-body font-[600] text-[18px] leading-[18px] w-[100%] 
                      bg-primary py-3 text-fg-inverse "
                          onClick={() =>
                            dispatch(updateDisplayTakePaymentDrawer(true))
                          }
                        >
                          TAKE PAYMENT
                        </button>

                        <button
                          className="font-body font-[600] text-[18px] leading-[18px] w-[100%] text-fg-inverse py-3  bg-primary "
                          onClick={() =>
                            dispatch(updateDisplayCloseOrderDrawer(true))
                          }
                        >
                          <TranslateText
                            textKey={"close_order"}
                            namespace="pos"
                          />
                        </button>
                      </div>
                    )}
                  </div>
                </>
              </div>
            ) : !Boolean(status) || status === "inProgress" ? (
              <>
                {orderLoading ? (
                  <div className="flex justify-center items-center p-3">
                    <CircularProgress size={24} />
                  </div>
                ) : (
                  <div className="w-full  rounded-t-[24px] bg-surface shadow-mobile-footer ">
                    <div className="flex justify-between p-3">
                      <TranslateText textKey={"amount"} namespace="pos" />

                      <span> {CURRENCY_FORMAT(itemTotalAmount)}</span>
                    </div>

                    {activePosType != POS_TYPE[3] ? (
                      <>
                        {invoicePostLoading ? (
                          <div className="flex justify-center items-center p-3">
                            <CircularProgress size={18} />
                          </div>
                        ) : (
                          <>
                            {order?.length ? (
                              <>
                                <div className="flex justify-center items-center gap-3 w-full mb-2  bg-surface">
                                  <Button
                                    type="primary"
                                    onClick={() => handleKOT("inProgress")}
                                    className=" text-[16px] w-[40%]"
                                    onMouseEnter={() => setPrintKOT(true)}
                                    onMouseLeave={() => setPrintKOT(false)}
                                  >
                                    {activePosType === POS_TYPE[0]
                                      ? "KOT"
                                      : "New Order"}
                                  </Button>

                                  <Button
                                    onClick={() => handleKOT("held")}
                                    className="text-[16px] w-[40%] border-[1px] border-primary text-primary"
                                  >
                                    <TranslateText
                                      textKey={"hold"}
                                      namespace="pos"
                                    />
                                  </Button>

                                  <Button
                                    type="primary"
                                    onClick={createBill}
                                    className=" text-[16px] w-[40%]"
                                  >
                                    <TranslateText
                                      textKey={"bill"}
                                      namespace="pos"
                                    />
                                  </Button>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="flex justify-center items-center gap-3 w-full mb-2  bg-surface">
                                  <Button
                                    type="primary"
                                    onClick={() => handleKOT("inProgress")}
                                    className=" text-[16px] w-[40%]"
                                    onMouseEnter={() => setPrintKOT(true)}
                                    onMouseLeave={() => setPrintKOT(false)}
                                  >
                                    {activePosType === POS_TYPE[0]
                                      ? "KOT"
                                      : "New Order"}
                                  </Button>

                                  <Button
                                    onClick={() => handleKOT("held")}
                                    className="text-[16px] w-[40%] border-[1px] border-primary text-primary"
                                  >
                                    <TranslateText
                                      textKey={"hold"}
                                      namespace="pos"
                                    />
                                  </Button>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <div className="flex w-full mb-2 border rounded-xl border-accent">
                        {invoicePostLoading ? (
                          <CircularProgress size={18} />
                        ) : (
                          <Button
                            onClick={() => handleKOT("inProgress", true)}
                            icon={<Bill />}
                            className="flex items-center justify-center flex-1 border-none text-accent text-[16px]"
                          >
                            <span className="hover:bg-primary text-fg-inverse w-full rounded bg-primary">
                              {" "}
                              <TranslateText textKey={"bill"} namespace="pos" />
                            </span>
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              <></>
            )}

            <DeleteOrderModal
              deletePopUp={deletePopUp}
              setDeletePopUp={setDeletePopUp}
            />

            {printKOT && (
              <GenerateKOT
                print={printKOT}
                val={componentRef}
                tableOrderDetails={tableOrderDetails}
                order={latestOrder}
                latestOrder={latestOrder}
              />
            )}

            {printInvoice && (
              <GenerateInvoice
                print={printInvoice}
                val={componentInvoiceRef}
                tableOrderDetails={tableOrderDetails}
                customer={customer}
              />
            )}

            <AttachRoomPartyDrawer
              total={total}
              invoice={invoicePostData}
              setIsCloseOrder={setIsCloseOrder}
              tableOrderDetails={tableOrderDetails}
              hotelId={hotelDetails?.id}
            />

            <CloseOrderDrawer
              total={Boolean(paid) ? total - paid : total}
              invoice={invoicePostData}
              setIsCloseOrder={setIsCloseOrder}
              tableOrderDetails={tableOrderDetails}
              hotelId={hotelDetails?.id}
            />
            <TakePaymentDrawer
              total={Boolean(paid) ? total - paid : total}
              invoice={invoicePostData}
              setIsCloseOrder={setIsCloseOrder}
              tableOrderDetails={tableOrderDetails}
              hotelId={hotelDetails?.id}
            />
            <ApplyDiscountDrawer
              itemPrice={itemPrice}
              discountInfo={invoicePostData?.discountInfo}
            />

            <EditPaymentDrawer
              isBookingListDrawer={false}
              drawerWidth={menuDrawer ? "33%" : "30%"}
              isPosComponent={true}
            />

            <Modal
              open={deletePartyModal}
              centered
              title=""
              width={"auto"}
              styles={{ mask: { backdropFilter: "blur(2px)" } }}
              onCancel={() => setDeletePartyModal(false)}
              closable={false} // Hides the close (cancel) icon
              footer={
                <div className="w-full flex gap-2 justify-center mt-5">
                  <Button
                    className="text-[1.1rem]  w-[11rem] h-[3rem] border-brand-border text-fg-muted rounded-[0.5rem] font-body font-[600] "
                    onClick={() => setDeletePartyModal(false)}
                  >
                    NO
                  </Button>
                  <Button
                    className="text-fg-inverse text-[1.1rem] rounded-xl  bg-primary w-[11rem] h-[3rem]"
                    onClick={() =>
                      deletePartyAndRoomFromPosInvoice(
                        invoicePostData,
                        allPayments,
                        setDeletePartyModal,
                      )
                    }
                  >
                    {false ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      <div>YES</div>
                    )}
                  </Button>
                </div>
              }
            >
              <div className="text-fg font-body font-[500] text-[18px]  ">
                Are you sure you want to remove Party/Booking from this Invoice?
              </div>
            </Modal>

            <MarkNCModal
              open={showNcModal}
              invoice={invoicePostData}
              posData={response}
              onCancel={() => setShowNcModal(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideContainer;
